export default {
  ENV: 'production',
  API_ENV: '',
  LOGIN: 'https://login.justsift.com',
  SENTRY: 'https://834a4adfd7154aeab403f2651536a2dc@sentry.io/176731',
  CSV_TEMPLATE_URL: 'https://siftprodcoredata.z13.web.core.windows.net/sift-templates/csv_source_sample.csv',
  ANALYTICS: {
    INTERCOM: {
      ajsName: 'Intercom',
      options: {
        appId: 'tudn7o48',
      },
    },
  },
};
